import { NavItem } from './nav-item';

export class ProfileNavItem extends NavItem {}
